import { setImageTimer } from '@/helpers/mediaUtils';
import { handleArrow } from '@/modules/actions/desktop/desktopArrowIconsAction';

// 動画終了後に次の動画を自動再生する関数
export const setupAutoPlayNextAction = () => {
  const movie = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .storeeel-movie');
  if (movie) {
    movie.addEventListener("ended", () => {
      handleArrow('next');
    });
  }

  // 画像は5秒後に次のメディアを表示
  const image = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .storeeel-media-image');
  if (image) {
    setImageTimer(() => {
      handleArrow('next');
    }, 5000);
  }
}
